import React from 'react';
import Input from '../../../components/BaseInput';

import amexImg from '../../../assets/credit-cards/amex.png';
import dinersImg from '../../../assets/credit-cards/diners.png';
import discoverImg from '../../../assets/credit-cards/discover.png';
import mastercardImg from '../../../assets/credit-cards/mastercard.png';
import visaImg from '../../../assets/credit-cards/visa.png';
import { baseUrl } from '../../../lib/config';

const amexReg = new RegExp('^3[47][0-9]');
const dinersReg = new RegExp('^3(?:0[0-5]|[68][0-9])[0-9]');
const discoverReg = new RegExp('^6(?:011|5[0-9]{2})');
const mastercardReg = new RegExp('^5[1-5][0-9]');
const visaReg = new RegExp('^4[0-9]');

export default function CreditCardInput({ value, onChange, name = 'number', error = false }) {
  let backgroundImage;

  if (amexReg.test(value)) {
    backgroundImage = amexImg;
  } else if (dinersReg.test(value)) {
    backgroundImage = dinersImg;
  } else if (discoverReg.test(value)) {
    backgroundImage = discoverImg;
  } else if (mastercardReg.test(value)) {
    backgroundImage = mastercardImg;
  } else if (visaReg.test(value)) {
    backgroundImage = visaImg;
  } else {
    backgroundImage = `${baseUrl}/api/v2/gift/payment-methods/logo/1`;
  }

  return (
    <div className="form-group card-input credit-card-number">
      <Input
        backgroundImage={backgroundImage}
        type="text"
        name={name}
        error={error}
        value={value}
        onChange={onChange}
        placeholder="0000 0000 0000 0000"
        autoComplete="cc-number"
      />
    </div>
  );
}
